import * as React from "react";
const SvgMarkerCircle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 50, viewBox: "0 0 40 50", ...props }, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse_19", "data-name": "Ellipse 19", cx: 20, cy: 25, r: 20, fill: "#fff" }));
export default SvgMarkerCircle;
